class ToggleSectionVisibility {
  constructor(container) {
    this.container = document.querySelector(container);
    
    if(!this.container){
       return;
    }
    this.triggerElement = this.container.querySelector('.register-btn a.sign-up');
    this.targetShowElement = this.container.querySelector('.sign-up-form');
    this.targetFormElement = this.container.querySelector('.form-container');
    this.targetElements = this.container.querySelectorAll('.section-double__content'); 
    this.login = this.container.querySelector('.login-btn-custom');
    this.form_type = this.getURLParameter('form_type');
    
    this.data_warning = this.targetFormElement.dataset.warning;
    
    this.init();
  }

  init() {
    this.triggerElement.addEventListener('click', () => {
      this.toggleVisibility();
    });
    if(this.login){
      this.login.addEventListener('click', () => {
        this.toggleVisibility();
      });
    }
    this.filterError();
  }

  filterError(){
    if (this.form_type) {
      if(this.form_type == "customer"){
        console.log(`Customer Form Type: ${this.form_type}`);
        this.prependMessage();
      }
    }
  }

  prependMessage() {
      const newsletterForm = document.querySelector('.newsletter-form');
  
      const messageDiv = document.createElement('div');
  
      messageDiv.textContent = this.data_warning;
      messageDiv.classList.add('already-signed-up');
  
      if (newsletterForm) {
          newsletterForm.prepend(messageDiv);
      } else {
          console.error('Newsletter form not found.');
      }
  }
    
  toggleVisibility() {
    this.targetElements.forEach((element) => {
      element.style.display = (element.style.display === "none") ? "block" : "none";
    });
    
    if (this.targetShowElement) {
        if (this.targetShowElement.style.display === "none") {
          this.targetShowElement.style.display = "block";
          this.targetShowElement.classList.add('fade-in-form'); 
        } else {
          this.targetShowElement.style.display = "none";
          this.targetShowElement.classList.remove('fade-in-form'); 
        }
      }

    if (this.targetFormElement) {
      this.targetFormElement.style.visibility = (this.targetFormElement.style.visibility === "hidden") ? "visible" : "hidden";
    }
  }


  getURLParameter(name) {
      const url = new URL(window.location.href);    
      const params = new URLSearchParams(url.search);
      return params.get(name);
  }
}

// Initialize the class
document.addEventListener('DOMContentLoaded', () => {
  const main_container = '.section-double__body';
  new ToggleSectionVisibility(main_container);
});